module.exports = __webpack_public_path__ + "img/main.b2395e2b.png";